import * as Con from "../containers";
import * as Com from "../components";

/**
 * 路由配置 Routes
 * @note import顺序与路由配置顺序保持一致
 * @note url 采用 aaa-bbb-ccc形式
 */
export const routes = [ 
  { path: "/", component: Com.Home }, 
  { path: "/home", component: Com.Home }, 
  { path: "/contact", component: Com.Contact }, 
  { path: "/dashboard", component: Com.DashBoard }, 
  { path: "/login", component: Con.Login }, 
  { path: "/get-api", component: Com.Api }, 
  { path: "/solutions", component: Com.Solutions }, 
  { path: "/todos", component: Con.Todos }, 
  { path: "/subreddit", component: Con.Subreddit }, 
  { path: "/about", component: Com.About, 
    routes: [ 
      {path: "/about/about", component: Com.About}, 
      {path: "/sbout/contact", component: Com.About} 
    ]
  },
  { path: "", component: Com.NoMatch } 
];



// WEBPACK FOOTER //
// ./usr/lib/ui/src/routes/routes.js